import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import VideosCatalog from "./pages/VideosCatalog";
import FestivalCalendar from "./pages/FestivalCalendar";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App bg-tattva-bg text-tattva-ink min-h-screen">
            <BrowserRouter>
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/videos" element={<VideosCatalog />} />
                        <Route
                            path="/calendar"
                            element={<FestivalCalendar />}
                        />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="bottom-center" />
            </BrowserRouter>
        </div>
    );
}

export default App;
